import * as XLSX from 'xlsx'

export const ReadFile = {
  methods: {
    ReadVCFFile (file, phoneNumbersList) {
      this.branjeVTeku = true
      let contacts = []
      let plainText = decodeURIComponent(escape(file.data))
      const vCards = plainText.split('END:VCARD').map(v => v.trim()).filter(v => v)

      vCards.forEach(vCard => {
        const lines = vCard.split('\n').map(line => line.trim())
        let novKontakt = {}

        lines.forEach(line => {
          if (line.startsWith('FN:')) {
            const [ime, priimek] = line.replace('FN:', '').split(' ')
            novKontakt.ime = ime || ''
            novKontakt.priimek = priimek || ''
          } else if (line.includes('TEL;') || line.includes('TEL:')) {
            let digits = line.replace(/\D/g, '')
            if (digits && digits.length === 9 && novKontakt.ime) {
              novKontakt.mobile = digits
              novKontakt.telefon = digits
              novKontakt.email = ''
              novKontakt.group = []
              novKontakt.idKontakt = 0
            }
          }
        })

        if (novKontakt.mobile) {
          if (!phoneNumbersList.find(x => x.mobile === novKontakt.mobile || x.telefon === novKontakt.telefon)) {
            contacts.push(novKontakt)
          } else {
            this.ShowWarningMessage({ message: `Kontakt ${novKontakt.mobile} že obstaja v seznamu.` })
          }
        }
      })

      return contacts
    },
    ReadExcelFile (file, phoneNumbersList) {
      return new Promise((resolve, reject) => {
        try {
          const binary = file.data
          const workbook = XLSX.read(binary, { type: 'binary' })
          const sheet = workbook.Sheets[workbook.SheetNames[0]]
          const jsonData = XLSX.utils.sheet_to_json(sheet)
          const contacts = []
          jsonData.forEach((row, index) => {
            const ime = row.ime || row.Ime || ''
            const priimek = row.priimek || row.Priimek || ''
            const telefon = String(row.telefon || row.Telefon || '').replace(/\D/g, '')
            const mobile = telefon
            if (telefon.length === 9 && ime) {
              if (!phoneNumbersList.some(x => x.mobile === telefon || x.telefon === telefon)) {
                contacts.push({
                  ime,
                  priimek,
                  telefon,
                  mobile,
                  email: '',
                  group: [],
                  idKontakt: 0
                })
              }
            }
          })
          resolve(contacts)
        } catch (err) {
          this.ShowWarningMessage({ message: 'Napaka pri obdelavi Excel datoteke.' })
          reject(err)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Kontakti/ReadFile.js